import {
    type GetAllUsersForAdminResponseType,
    type GetAllUsersForAdminRequestType
} from "./type";
import {
    request
} from "../request";

const getAllUsersForAdmin = async (params: GetAllUsersForAdminRequestType): Promise<GetAllUsersForAdminResponseType> => {
    const serializedParams = {
        ...params
    } as Record<string, string | string[] | number | boolean | undefined>;

    if (Array.isArray(serializedParams.sectorIDs)) {
        serializedParams.sectorIDs = serializedParams.sectorIDs.join(",");
    }

    const filteredParams = Object.fromEntries(
        Object.entries(serializedParams).filter(entry => entry[1] !== undefined && entry[1] !== null && entry[1] !== "")
    );
    const queryStr = Object.keys(filteredParams).length > 0 ? `?${new URLSearchParams(filteredParams as Record<string, string>).toString()}` : "";
    return await request<GetAllUsersForAdminResponseType>(`/user/getAllUsersForAdmin${queryStr}`, {
        method: "GET"
    });
};
export default getAllUsersForAdmin;
